<template lang="pug">
  .traction__map-captain
    MsgInfo( :data="data.user" :info="data.info")
    MsgWeeks( :data="data.weeks" :isUpdate="isUpdate" :info="data.info")
</template>

<script>
import { mapState } from 'vuex';
import MsgInfo from './MsgInfo';
import MsgWeeks from './MsgWeeks';

export default {
  components: { MsgInfo, MsgWeeks },
  props: ['data'],
  computed: {
    ...mapState('auth', {
      userId: s => s.data.user.id,
      isAdmin: s => s.data.user.permissions.isAdmin
    }),
    ...mapState('msg', {
      users: s => s.data.users
    }),
    // isUpdate(){
    //   return this.data.user.id == this.userId || this.isAdmin ||  this.users.some( el => ( el.isManager  && el.id == this.data.managerId && el.id == this.userId)) || this.users.some( el => ( el.isTracker  && el.id == this.data.trackerId && el.id == this.userId))
    // },
    isUpdate() {
      return (
        this.data.user.id == this.userId ||
        this.isAdmin ||
        this.users.some(
          el => (el.isManager || el.isTracker) && el.id == this.userId
        )
      );
    }
  }
};
</script>
